import request from "@/utils/request";
import requestCache from "@/utils/requestWithCache";

export function getPartners(params) {
  return requestCache({
    url: `/api/admin/banners/partners/`,
    method: "get",
    params,
  });
}
export function getPartnerById(partnerId) {
  return request({
    url: `/api/admin/banners/partners/${partnerId}/`,
    method: "get",
  });
}
export function createPartner(data) {
  return request({
    url: `/api/admin/banners/partners/`,
    method: "post",
    data,
  });
}
export function deletePartner(partnerId) {
  return request({
    url: `/api/admin/banners/partners/${partnerId}/`,
    method: "delete",
  });
}
export function updatePartner(partnerId, data) {
  return request({
    url: `/api/admin/banners/partners/${partnerId}/`,
    method: "patch",
    data,
  });
}
